<script setup>
import { computed } from 'vue';
import SLAMetricCard from './SLAMetricCard.vue';
import { EMPTY_METRIC_MARKER } from 'dashboard/helper/reportDuration';

const props = defineProps({
  hitRate: {
    type: String,
    required: true,
  },
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

// Zero conversas com SLA aplicado nao e 100% de acerto: e nenhuma medida.
// Producao tem ZERO linhas na tabela em todas as contas, entao o cartao dizia
// "100%" para quem nunca usou SLA.
const hasMeasure = computed(() => Number(props.noOfConversations) > 0);
const hitRateValue = computed(() =>
  hasMeasure.value ? props.hitRate : EMPTY_METRIC_MARKER
);
const missesValue = computed(() =>
  hasMeasure.value ? props.noOfBreaches : EMPTY_METRIC_MARKER
);
</script>

<template>
  <div
    class="flex sm:flex-row flex-col w-full gap-4 sm:gap-14 shadow outline-1 outline outline-n-container rounded-2xl bg-n-solid-2 px-6 py-5"
  >
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.HIT_RATE.LABEL')"
      :value="hitRateValue"
      :tool-tip="$t('SLA_REPORTS.METRICS.HIT_RATE.TOOLTIP')"
      :is-loading="isLoading"
    />

    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.LABEL')"
      :value="missesValue"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.LABEL')"
      :value="noOfConversations"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.TOOLTIP')"
      :is-loading="isLoading"
    />
  </div>
</template>
